import cn from "../../lib/classnames";
import gradientStyles from "../../styles/Gradient.module.css";
import React, {useState} from "react";
import styles from "./ScrollLock.module.css";

const strings = {
    unlock: "Tap to Expand",
    lock: "Tap to Collapse",
};

type Props = {
    children: React.ReactNode;
};

export default function ScrollLock(props: Props) {
    const [locked, setLocked] = useState(true);

    function toggleLock() {
        setLocked((l) => !l);
    }

    return (
        <div className={cn(styles.container, locked ? styles.locked : styles.unlocked)}>
            {props.children}
            <button
                type="button"
                onClick={toggleLock}
                className={cn(gradientStyles.grey, styles.button)}
            >
                {locked ? strings.unlock : strings.lock}
            </button>
        </div>
    );
}
